declare namespace $ {

	type $mol_link__title_shm_hitalama_vk_lists_creating_1 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_link['title'] >
	>
	type $mol_link__arg_shm_hitalama_vk_lists_creating_2 = $mol_type_enforce<
		ReturnType< $shm_hitalama_vk_lists_creating['cancel_arg'] >
		,
		ReturnType< $mol_link['arg'] >
	>
	type $mol_string__value_shm_hitalama_vk_lists_creating_3 = $mol_type_enforce<
		ReturnType< $shm_hitalama_vk_lists_creating['name'] >
		,
		ReturnType< $mol_string['value'] >
	>
	type $mol_labeler__title_shm_hitalama_vk_lists_creating_4 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_labeler['title'] >
	>
	type $mol_labeler__content_shm_hitalama_vk_lists_creating_5 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_labeler['content'] >
	>
	type $mol_button_major__title_shm_hitalama_vk_lists_creating_6 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_major['title'] >
	>
	type $mol_button_major__click_shm_hitalama_vk_lists_creating_7 = $mol_type_enforce<
		ReturnType< $shm_hitalama_vk_lists_creating['add'] >
		,
		ReturnType< $mol_button_major['click'] >
	>
	type $shm_hitalama_vk_group_search__token_str_shm_hitalama_vk_lists_creating_8 = $mol_type_enforce<
		ReturnType< $shm_hitalama_vk_lists_creating['token_str'] >
		,
		ReturnType< $shm_hitalama_vk_group_search['token_str'] >
	>
	type $shm_hitalama_vk_group_search__buttons_shm_hitalama_vk_lists_creating_9 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $shm_hitalama_vk_group_search['buttons'] >
	>
	type $mol_view__sub_shm_hitalama_vk_lists_creating_10 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_image__uri_shm_hitalama_vk_lists_creating_11 = $mol_type_enforce<
		ReturnType< $shm_hitalama_vk_lists_creating['photo_uri'] >
		,
		ReturnType< $mol_image['uri'] >
	>
	type $mol_button_minor__sub_shm_hitalama_vk_lists_creating_12 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_button_minor['sub'] >
	>
	type $mol_button_minor__click_shm_hitalama_vk_lists_creating_13 = $mol_type_enforce<
		ReturnType< $shm_hitalama_vk_lists_creating['remove'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_view__sub_shm_hitalama_vk_lists_creating_14 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_shm_hitalama_vk_lists_creating_15 = $mol_type_enforce<
		ReturnType< $shm_hitalama_vk_lists_creating['groups'] >
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_button_major__title_shm_hitalama_vk_lists_creating_16 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_major['title'] >
	>
	type $mol_button_major__click_shm_hitalama_vk_lists_creating_17 = $mol_type_enforce<
		ReturnType< $shm_hitalama_vk_lists_creating['save'] >
		,
		ReturnType< $mol_button_major['click'] >
	>
	type $mol_button_major__enabled_shm_hitalama_vk_lists_creating_18 = $mol_type_enforce<
		ReturnType< $shm_hitalama_vk_lists_creating['save_enabled'] >
		,
		ReturnType< $mol_button_major['enabled'] >
	>
	export class $shm_hitalama_vk_lists_creating extends $mol_section {
		cancel_arg( ): Record<string, any>
		Creating_cancel( ): $mol_link
		name( next?: string ): string
		Name( ): $mol_string
		Name_label( ): $mol_labeler
		token_str( ): string
		group_dto_current( ): ReturnType< ReturnType< $shm_hitalama_vk_lists_creating['Search'] >['dto'] >
		add( next?: any ): any
		Add( ): $mol_button_major
		Search( ): $shm_hitalama_vk_group_search
		Add_block( ): $mol_view
		photo_uri( id: any): string
		Photo( id: any): $mol_image
		Remove_icon( id: any): $mol_icon_close
		remove( id: any, next?: any ): any
		Remove( id: any): $mol_button_minor
		Group( id: any): $mol_view
		groups( ): readonly(any)[]
		Creating_list( ): $mol_view
		save( next?: any ): any
		save_enabled( ): boolean
		Save( ): $mol_button_major
		token( ): $shm_hitalama_vk_token | null
		title( ): string
		param( ): string
		groups_list( next?: readonly(string)[] ): readonly(string)[]
		content( ): readonly(any)[]
	}
	
}

//# sourceMappingURL=creating.view.tree.d.ts.map